module.exports = __webpack_public_path__ + "static/media/user_avatar_gray.e4946c70.svg";